import { configureStore } from '@reduxjs/toolkit'
import accountOverviewReducer from "./slices/accountOverviewSlice"
import projectsReducer from "./slices/projectsSlice"
import userRededucer from "./slices/userSlice"
import fetchReducer from "./slices/fetchStatusSlice"
export default configureStore({
  reducer: {
    accountOverview: accountOverviewReducer,
    projects: projectsReducer,
    auth: userRededucer,
    fetchStatus: fetchReducer
  },
})